import { buildProps, definePropType } from '@ll-plus/utils'
import { SelectProps } from 'ant-design-vue'

import type { SizeType } from 'ant-design-vue/es/config-provider'
import type { ExtractPropTypes } from 'vue'
import { tagShapeType } from '../../tag/src/tag.js'
import type TagCatalog from './tag-catalog.vue'

export type TagCatalogValueType = string | number | null

export interface TagCatalogOption {
  label: any
  value: TagCatalogValueType
  icon?: string
}

export const tagCatalogProps = buildProps({
  value: {
    type: definePropType<SelectProps['value']>([Array, String, Number]),
  },
  fieldMappings: {
    type: Object,
    default: () => ({
      label: 'label',
      value: 'value',
      icon: 'icon',
    }),
  },
  options: {
    type: definePropType<TagCatalogOption[]>(Array),
    default: () => [],
  },
  size: {
    type: definePropType<SizeType>(String),
    default: 'middle',
  },
  bordered: {
    type: Boolean,
    default: true,
  },
  tagGap: {
    type: Number,
    default: 8,
  },

  displayMode: {
    type: String,
    values: ['query', 'light'],
    default: undefined,
  },
  selectionMode: {
    type: String,
    values: ['multiple', 'single'],
    default: 'multiple',
  },
  showSelectAll: {
    type: Boolean,
    default: false,
  },
  selectAllText: {
    type: String,
    default: '全部',
  },
  activeColor: {
    type: String,
    default: undefined,
  },
  activeStyle: {
    type: Object,
    default: () => ({}),
  },
  // 超出显示方式 collapse收起 | wrap换行
  overflowDisplay: {
    type: String,
    values: ['collapse', 'wrap'],
    default: 'collapse',
  },
  // 标签最大宽度
  tagMaxWidth: {
    type: Number,
    default: 0,
  },
  // 更多标签弹窗宽度
  moreTagWidth: {
    type: Number,
    default: 100,
  },

  // 标签形状
  shape: {
    type: definePropType<tagShapeType>(String),
    default: 'round',
  },
  // 标签颜色
  color: {
    type: String,
    default: undefined,
  },
  // 是否显示图标
  showIcon: {
    type: Boolean,
    default: false,
  },
  // 默认图标
  defaultIcon: {
    type: String,
    default: '',
  },
  // 图标大小
  iconSize: Number,

  // 图标方位
  iconDirection: {
    type: String,
    values: ['left', 'right'],
    default: 'left',
  },
  customStyle: {
    type: Object,
    default: () => ({}),
  },
} as const)

export const tagCatalogEmits = {
  click: (e: MouseEvent, item: TagCatalogOption) => !!item,
  select: (
    val: TagCatalogValueType,
    item: TagCatalogOption,
    list: TagCatalogValueType[],
  ) => !!list,
  selectAll: (val: boolean, list: TagCatalogValueType[]) => !!list,
}

// props
export type TagCatalogProps = ExtractPropTypes<typeof tagCatalogProps>

// emits
export type TagCatalogEmits = typeof tagCatalogEmits

// instance
export type TagCatalogInstance = InstanceType<typeof TagCatalog>
